import React, { useState, useRef, useEffect, useCallback } from "react"
import { Link, useLocation } from "react-router-dom"
import classNames from "classnames"

import { mainMenuExpanded } from "utils/segment"

import Container from "./Container"
import NavbarMenu from "./NavbarMenu"

import Logo from "../assets/logo.svg"
import BravenHealthLogo from "../assets/braven-health-logo.png"
import Menu from "../assets/menu.svg"
import MenuClose from "../assets/menu-close.svg"
import LotsaHelpingHands from "../assets/LotsaHelpingHands.png"
import Kaiser from "../assets/kaiser.png"
import Row from "./Row"
import BlueCrossBlueShieldRhodeIslandLogo from "../assets/blue-cross-blue-shield-rhode-island-logo.svg"

const Navbar = ({
  mode,
  navbarPhoneNumber,
  partnerLogoImageComponent = null,
}) => {
  const { pathname } = useLocation()
  const [menuCollapsed, setMenuCollapse] = useState(true)
  const [showButton, setShowButton] = useState(false)
  const buttonRef = useRef(null)
  const menuRef = useRef(null)

  const toggleMenu = useCallback(() => {
    if (menuCollapsed) mainMenuExpanded()
    setMenuCollapse(!menuCollapsed)
  }, [menuCollapsed])

  useEffect(() => {
    function handleClick(event) {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        toggleMenu()
      }
    }

    function onKeyDown(event) {
      if (!menuCollapsed && event.keyCode === 27) {
        toggleMenu()
      }
    }

    document.addEventListener("mousedown", handleClick)
    document.addEventListener("keydown", onKeyDown)

    return () => {
      document.removeEventListener("mousedown", handleClick)
      document.removeEventListener("keydown", onKeyDown)
    }
  }, [toggleMenu, menuCollapsed])

  function handleScroll() {
    if (window.pageYOffset > 600) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const classes = classNames(
    pathname === "/p/bravenhealth"
      ? "braven-health-navbar flex"
      : "navbar flex",
    {
      "navbar--menu-open": !menuCollapsed,
    }
  )

  const renderMenuButton = () => {
    if (mode === "partnership") return null

    if (pathname === "/pals/signup") {
      return (
        showButton && (
          <button
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              })
            }}
            className="apply-now flow-button flow-button--primary"
          >
            Apply Now
          </button>
        )
      )
    }

    return (
      <button
        className="menu-button ml-30"
        onClick={toggleMenu}
        ref={buttonRef}
      >
        <img
          src={menuCollapsed ? Menu : MenuClose}
          alt="Menu"
          className="menu"
        />
      </button>
    )
  }

  if (mode === "lite") {
    return (
      <nav className={classes} role="navigation" aria-label="main navigation">
        <Container flex className="align-center">
          <div className="navbar__brand text-center">
            {pathname === "/p/bravenhealth" && (
              <img
                className="braven-health-logo"
                src={BravenHealthLogo}
                alt="Braven Health"
              />
            )}
            {pathname === "/p/bcbsri" && (
              <img
                className="mr-30 bcbsri"
                src={BlueCrossBlueShieldRhodeIslandLogo}
                alt="Blue Cross Blue Shield Rhode Island"
              />
            )}
            <Link to="/">
              <img src={Logo} alt="Papa" className="brand" />
            </Link>
          </div>
        </Container>
      </nav>
    )
  }

  return (
    <nav className={classes} role="navigation" aria-label="main navigation">
      <Container flex className="align-center">
        <div className="navbar__brand">
          <Row>
            {pathname === "/p/bravenhealth" && (
              <img
                className="braven-health-logo"
                src={BravenHealthLogo}
                alt="Braven Health"
              />
            )}
            {partnerLogoImageComponent}
            <Link to={mode === "partnership" ? "#" : "/"}>
              <img src={Logo} alt="Papa" className="brand" />

              {pathname === "/lotsahelpinghands" && (
                <img
                  src={LotsaHelpingHands}
                  alt="Papa"
                  className="ml-30 lotsa"
                />
              )}

              {pathname === "/p/kaiser" && (
                <img
                  src={Kaiser}
                  alt="Kaiser Permanente"
                  className="ml-30 kaiser"
                />
              )}
            </Link>
          </Row>
        </div>

        {mode !== "partnership" &&
          mode !== "amazon" &&
          mode !== "braven-health" && (
            <>
              <div className="navbar__nav flex responsive-nav-menu">
                <Link to="/pals/signup" className="nav-link">
                  Become a Papa Pal
                </Link>
                <Link to="/enterprise" className="nav-link">
                  Enterprise
                </Link>
              </div>
            </>
          )}

        <div className="navbar__nav flex align-center ml-auto">
          {renderMenuButton()}
        </div>
      </Container>

      <NavbarMenu
        ref={menuRef}
        toggleMenu={toggleMenu}
        menuCollapsed={menuCollapsed}
      />
    </nav>
  )
}

export default Navbar
